module.exports = __webpack_public_path__ + "static/media/terrace-6.2d9c8c22.jpg";